import { render, staticRenderFns } from "./facebookemail.vue?vue&type=template&id=6e083ff4&scoped=true"
import script from "./facebookemail.vue?vue&type=script&lang=js"
export * from "./facebookemail.vue?vue&type=script&lang=js"
import style0 from "./facebookemail.vue?vue&type=style&index=0&id=6e083ff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e083ff4",
  null
  
)

export default component.exports